import { ListViewFilters } from '@razorpay/blade/components';
import { SalaryStructure } from 'components/SalaryStructure/types';
import { useFilters } from 'hooks/useFilters';
import React, { useEffect, useState } from 'react';
import { debounceV2 } from 'utils/Debounce';
import StatusFilter from './StatusFilter';

const Filters = ({ structures }: { structures: SalaryStructure[] }) => {
  const [search, setSearch] = useState('');

  const { removeFilter, applyFilter } = useFilters({
    filtersMap: {
      search: 'search',
    },
  });

  const handleClearSearch = () => {
    setSearch('');
  };

  const debouncedSearch = debounceV2(async (searchText: string) => {
    applyFilter('search', searchText);
  }, 500);

  useEffect(() => {
    if (search === '') {
      debouncedSearch.cancel();
      removeFilter('search');
      return;
    }

    debouncedSearch(search);
  }, [search]);

  const handleSearchChange = ({ value }: { value?: string | undefined }) => {
    setSearch(value || '');
  };

  return (
    <ListViewFilters
      quickFilters={<StatusFilter structures={structures} />}
      onSearchChange={handleSearchChange}
      searchValuePlaceholder="Search salary structure"
      onSearchClear={handleClearSearch}
    />
  );
};

export default Filters;
